<template>
  <div class="wrapper">
    <p v-if="infoText" class="info-text">{{ infoText }}</p>
    <ui-button color="primary" :to="to">
      {{ label }}
    </ui-button>
  </div>
</template>

<script>
export default {
  name: "ButtonWithInfoText",
  props: {
    infoText: {
      type: String
    },
    label: {
      type: String,
      required: true
    },
    to: {
      type: [Object, String, Array],
      default: undefined
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex-grow: 1;
  padding: 0 $spacing * 5;
}

.info-text {
  text-align: center;
  @include font-size(14px);
  font-weight: 400;
  color: $text;
  margin-bottom: $spacing * 3;
}
</style>
